import { ledgerNameSchema } from '@kasboek/shared';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useCallback, useState, type FormEvent } from 'react';
import { authKeys } from '../../auth/constants/auth.constant';
import { ledgerKeys } from '../constants/ledger.constant';
import { ledgerService } from '../services/ledger.service';

async function createAndActivate(name: string): Promise<void> {
  const created = await ledgerService.create(name);
  await ledgerService.setActive(created.id);
}

export function useCreateLedger(onCreated: () => void) {
  const queryClient = useQueryClient();
  const [name, setName] = useState('');
  const [error, setError] = useState<string | null>(null);

  const mutation = useMutation({
    mutationFn: createAndActivate,
    onSuccess: () => {
      setName('');
      void queryClient.invalidateQueries({ queryKey: ledgerKeys.all });
      void queryClient.invalidateQueries({ queryKey: authKeys.me });
      onCreated();
    },
  });
  const { mutate, reset } = mutation;

  const changeName = useCallback(
    (value: string) => {
      setName(value);
      setError(null);
      reset();
    },
    [reset],
  );

  const submit = useCallback(
    (event: FormEvent<HTMLFormElement>) => {
      event.preventDefault();
      const parsed = ledgerNameSchema.safeParse({ name });
      if (!parsed.success) {
        setError(parsed.error.issues[0]?.message ?? 'Nama tidak valid.');
        return;
      }
      mutate(parsed.data.name);
    },
    [mutate, name],
  );

  return { name, changeName, submit, error: error ?? mutation.error?.message ?? null, isCreating: mutation.isPending };
}
